// Stars, Gems and Charms. Draft numbers from SCOPE.md section 6; tune from the log.

import type { Category, RoundSummary } from './types';

export const BASE_GEMS = 6;
export const RUNG_BONUS = 0.15;
export const DOOR_GEMS = 10;
export const DOOR_CAP_PER_VISIT = 5;

export interface Reward { gems: number; stars: 0 | 1 | 2 | 3; accuracy: number }

export function roundReward(category: Category, level: number, s: RoundSummary): Reward {
  const accuracy = s.attempts ? s.correct / s.attempts : 0;
  if (category === 'fun') return { gems: 0, stars: 0, accuracy };
  if (s.attempts === 0) return { gems: 0, stars: 0, accuracy: 0 };
  let gems = BASE_GEMS * (1 + RUNG_BONUS * level) * accuracy;
  if (s.perfect && s.attempts >= 3) gems *= 2;
  gems = Math.max(s.correct > 0 ? 1 : 0, Math.round(gems));
  let stars: 0 | 1 | 2 | 3 = 0;
  if (s.attempts >= 3) {
    if (accuracy >= 0.95) stars = 3;
    else if (accuracy >= 0.8) stars = 2;
    else if (accuracy >= 0.6) stars = 1;
  }
  return { gems, stars, accuracy };
}

/** Star thresholds for the nth learning game in registry order (0-based). */
export function starsToUnlock(n: number): number {
  // 0, 0, 0, 3, 6, 10, 15, 21, 28, ... triangular after the first three
  if (n < 3) return 0;
  const k = n - 2;
  return (k * (k + 1)) / 2 + k * 1; // 3, 7, 12, 18, 25 ... slightly steeper than triangular
}
